import { selectGeneralSelectionDate } from 'src/app/store/general-selection/selectors/general-selection.selectors';
import { ClientFacade } from 'src/app/store/client/facade/client.facade';
import { IClient, IEntity } from 'src/app/store/client/reducers/client.reducers';
import { selectSelectedClientGroup } from 'src/app/store/client/selectors/client.selectors';
import { IAppState } from 'src/app/store/state/app.state';
import { KiwiSaverRedirectService } from './../utils/kiwisaver-redirect.service';
import { Observable, of, Subscription } from 'rxjs';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';

@Injectable()
export class ClientKiwiSaverGuard  {

    clientsSelected: boolean;
    allClientInvestorEntities: IEntity[];
    selectedDate: Date;

    constructor(
        private kiwiSaverRedirectService: KiwiSaverRedirectService,
        private router: Router,
        private store: Store<IAppState>,
        private clientFacade: ClientFacade,) {
        
        this.store.pipe(select(selectGeneralSelectionDate))
        .subscribe((d: Date) => {
            this.selectedDate = d;
        });
        
        this.store.pipe(select(selectSelectedClientGroup))
        .subscribe((group: IClient) => {
            this.clientsSelected = (group.GroupId !== 0 || group.Members.length > 0);
        });
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        // TODO: #entity refactor. retrieve the investor entities from facade, and only when it is retrieved and doesn't exist
        if (!this.clientsSelected) {
            this.clientFacade.getClientInvestorEntities(this.selectedDate);
        }
        return this.kiwiSaverRedirectService.getRedirectRoute$(this.clientsSelected)
        .pipe(
            switchMap((forcedRegistrationRedirectRoute: string) => {
                if (forcedRegistrationRedirectRoute !== '*' && forcedRegistrationRedirectRoute !== state.url) {
                    this.router.navigateByUrl(forcedRegistrationRedirectRoute);
                    return of(false);
                } else {
                    return of(true);
                }
            })
        );
    }
}
